import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { DatabaseUpstreamDatasourcesFilteredByTableQuery, DatabaseUpstreamDatasourcesFilteredByTableQueryVariables, DatabaseUpstreamDatasourcesQuery, DatabaseUpstreamDatasourcesQueryVariables, DatasourcesDisplayGridRowDataFragment, PublishedDatasourceSortOrder , DatabaseUpstreamDatasourcesFilteredByTableDocument , DatabaseUpstreamDatasourcesDocument } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper
} from '../../../data-catalog-shared';
import {
  DatasourcesDisplayGrid,
  DatasourcesDisplayGridRowData,
  getRowDataForDatasource,
} from '../sharedDisplayGrid/DatasourcesDisplayGrid';
import { DatasourcesValidSortFields } from '../sorting/sortProviders/DatasourcesGridSortProvider';

type QueryVariables = DatabaseUpstreamDatasourcesQueryVariables;
type QueryResults = DatabaseUpstreamDatasourcesQuery;
type QueryResultListNode = DatasourcesDisplayGridRowDataFragment;
type GridRowData = DatasourcesDisplayGridRowData;

type QueryVariablesWithFilter = DatabaseUpstreamDatasourcesFilteredByTableQueryVariables;
type QueryResultsWithFilter = DatabaseUpstreamDatasourcesFilteredByTableQuery;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.databases && resultData.databases[0] &&
    resultData.databases[0].upstreamDatasourcesConnection;
}

function selectConnectionListResultForFilteredQuery(
  resultData: QueryResultsWithFilter
): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.tables && resultData.tables[0] &&
    resultData.tables[0].upstreamDatasourcesConnection;
}

export type DatabaseUpstreamDatasourcesQueryGridProps =
  GridSortProps<DatasourcesValidSortFields> & {
    readonly databaseId: string;
    readonly filteredTableId: string | null;
    readonly rowCount: number | null;
  };

export function DatabaseUpstreamDatasourcesQueryGrid(props: DatabaseUpstreamDatasourcesQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyUpstreamDatasourcesLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyUpstreamFilteredDatasourcesLineageGridMessage();

  return (
    props.filteredTableId ? (
      <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNode, GridRowData>
        queryGql={DatabaseUpstreamDatasourcesFilteredByTableDocument}
        partialQueryVariables={{ tableId: props.filteredTableId, orderBy: props.orderBy as PublishedDatasourceSortOrder }}
        selectConnectionListResult={selectConnectionListResultForFilteredQuery}
        mapResultNode={getRowDataForDatasource}
      >
        {({ rowStore }) =>
          <DatasourcesDisplayGrid
            rowStore={rowStore}
            emptyGridMessage={emptyFilteredGridMessage}
            rowCount={props.rowCount}
            orderBy={props.orderBy}
            updateSortOrder={props.updateSortOrder}
          />
        }
      </PaginatedQueryWrapper>
    ) : (
      <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
        queryGql={DatabaseUpstreamDatasourcesDocument}
        partialQueryVariables={{ databaseId: props.databaseId, orderBy: props.orderBy as PublishedDatasourceSortOrder }}
        selectConnectionListResult={selectConnectionListResult}
        mapResultNode={getRowDataForDatasource}
      >
        {({ rowStore }) =>
          <DatasourcesDisplayGrid
            rowStore={rowStore}
            emptyGridMessage={emptyGridMessage}
            rowCount={props.rowCount}
            orderBy={props.orderBy}
            updateSortOrder={props.updateSortOrder}
          />
        }
      </PaginatedQueryWrapper>
    )
  )
}
